/*
 * Loads in the Homepage Slider and it's settings.
 */
(function ($) {

	$(document).ready(function () {

		var item_length = $('.slide').length - 1;

		var slider = $('#site-leadin').slick({
			lazyLoad: 'ondemand',
			dots: true,
			autoplay:true,
			autoplaySpeed:4200,
			speed:1800,
			infinite: true
		});

		slider.on('afterChange', function(event, slick, currentSlide, nextSlide){
			if( item_length === slider.slick('slickCurrentSlide') ){
				// slider.slick('slickPause');
			}
		});

	});

})(jQuery);